export default "__VITE_ASSET__CM_VEjOZ__"